import {
  BookingStatus,
  DriverProfileStatus,
  RideStatus,
  TransactionStatus,
} from "./enums";

const success = [
  BookingStatus.CONFIRMED,
  BookingStatus.PASSED,
  DriverProfileStatus.APPROVED,
  RideStatus.ON_GOING,
  TransactionStatus.PENDING,
];

const neutral = [
  BookingStatus.WAITING,
  DriverProfileStatus.IN_REVIEW,
  RideStatus.NO_DRIVER_FOUND,
  TransactionStatus.WAITING_FOR_PAYMENT,
];
const danger = [
  BookingStatus.CANCELED,
  BookingStatus.REFUSED,
  DriverProfileStatus.DECLINED,
  DriverProfileStatus.BLOCKED,
  RideStatus.USER_CANCELLED,
  RideStatus.DRIVER_CANCELLED,
  RideStatus.ADMIN_CANCELLED,
  TransactionStatus.CANCELLED,
];
const completed = [
  BookingStatus.CASH_PRE_PAYMENT,
  RideStatus.COMPLETED,
  DriverProfileStatus.IN_REVIEW,
  TransactionStatus.COMPLETED,
];

export const getBadgeClassNameByStatus = (status: string) => {
  const itemStatus = status as
    | BookingStatus
    | DriverProfileStatus
    | RideStatus
    | TransactionStatus;
  if (success.includes(itemStatus)) return "badge-success";
  if (danger.includes(itemStatus)) return "badge-danger";
  if (completed.includes(itemStatus)) return "badge-completed";
  if (neutral.includes(itemStatus)) return "badge-neutral";
  return "badge-neutral";
};
